import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';
import commonStyles from '../../Common/commonStyles';
import SpecificationFiles from './SpecificationFiles';
const styles = StyleSheet.create({
    descriptionContainer: {
        marginHorizontal: commonStyles.marginHorizontal,
    },
    descriptionTitle: Object.assign(Object.assign({}, commonStyles.fontM), { marginBottom: 5, fontWeight: 'bold' }),
    description: Object.assign(Object.assign({}, commonStyles.fontS), { marginBottom: 25, paddingRight: 60 }),
});
function DescriptionPage({ description, files, t }) {
    return (React.createElement(View, { style: styles.descriptionContainer, wrap: false },
        React.createElement(Text, { style: styles.descriptionTitle }, t('additional_description')),
        React.createElement(Text, { style: styles.description }, description || t('no_specification_description')),
        (files === null || files === void 0 ? void 0 : files.length) > 0 && React.createElement(SpecificationFiles, { files: files })));
}
export default withTranslation('specification')(DescriptionPage);
